import { ownedDirectHref } from '@/lib/owned-hosts';
import { localizeHref } from '@/paraglide/runtime.js';

/**
 * The outbound "visit" link of a listing.
 *
 * Normally it goes through the /go/{slug} click-tracking redirect. /go is
 * disallowed in robots.txt, so that link can never pass link equity whatever
 * its `rel` says. A listing whose website is an owned host (listing `on`) links
 * straight to the site instead, with `rel="noopener"` so the destination still
 * sees the referrer (analytics, Search Console). Click counting is skipped for
 * those direct links.
 */
export function outboundLink(tool: {
  slug: string;
  website?: string | null;
  linkPolicy?: 'dofollow' | 'nofollow';
}): { href: string | null; rel: string } {
  const direct = ownedDirectHref(tool.website);
  if (direct) return { href: direct, rel: 'noopener' };
  return {
    href: tool.website ? localizeHref(`/go/${tool.slug}`) : null,
    rel: tool.linkPolicy === 'nofollow' ? 'noopener noreferrer nofollow' : 'noopener noreferrer',
  };
}
